'use client'

import { LAYOUT_TEST_IDS } from '@common/common-test-ids.const'

import { useLayoutStore } from '@stores/layout/layout.store'

import { CreateProjectDialog } from '../../CreateProjectDialog'

export function CreateProjectDialogContainer() {
  const open = useLayoutStore((state) => state.createProjectDialogOpen)
  const onOpenChange = useLayoutStore((state) => state.setCreateProjectDialogOpen)

  return (
    <div data-testid={LAYOUT_TEST_IDS.createProjectDialogContainer} style={{ display: 'contents' }}>
      <CreateProjectDialog open={open} onOpenChange={onOpenChange} />
    </div>
  )
}
